<div class="grid-2col input-grid-gaps pt-2">
    <app-date-input
        [form]="form"
        id="dateFrom"
        [prefix]="prefix"
    ></app-date-input>

    <app-date-input
        [form]="form"
        id="dateTo"
        [prefix]="prefix"
    ></app-date-input>

    @if (!item) {
        <app-work-detail-select-service
            (selectedService)="form.patchValue({ serviceId: $event })"
            [preselected]="form.value.serviceId"
            [allowedTypes]="[ServiceTypeEnum.SOCIAL]"
            [required]="true"
        ></app-work-detail-select-service>

        @if (form.value.dateFrom && form.value.serviceId) {
            <app-select-person
                [form]="form"
                [serviceId]="form.value.serviceId"
                [additionalFilter]="personAdditionalFilter()"
            ></app-select-person>
        }
    }

    <app-social-service-select-offer
        class="fr-2"
        [form]="form"
        id="offers"
        [serviceId]="form.value.serviceId"
        [allowedTypes]="[SocialServiceOperationEnum.BILL]"
        [singleSelectedMode]="item !== null"
    ></app-social-service-select-offer>

    @if (conflictedOffers().toClose.length > 0) {
        <app-warn-float-message class="fr-2" size="small">
            <div class="flex gap align-items-center">
                <div class="flex flex-1 gap-small align-items-center">
                    <span>{{ 'waitingList.client.messages.conflictedOffers' | translate }}</span>
                    @for (offer of conflictedOffers().toClose; track $index) {
                        <p-chip
                            [label]="$any(offer.offer) | formatOfferDuration"
                            [pTooltip]="offer.offer.name"
                            [ngStyle]="{ 'background-color': offer.offer.color || DEFAULT_TAG_COLOR, 'border-radius': '16px', color: (offer.offer.color || DEFAULT_TAG_COLOR) | colorContrast }"
                        ></p-chip>
                    }
                </div>

                <app-button
                    (clickEvent)="closeConflictedOffers()"
                    size="small"
                    label="waitingList.client.messages.closeThisOffers">
                </app-button>
            </div>
        </app-warn-float-message>
    }

    @if (conflictedOffers().notToClose.length > 0) {
        <app-error-float-message class="fr-2" size="small">
            <div class="flex flex-1 gap-small align-items-center">
                <span>{{ 'waitingList.client.messages.conflictedOffers' | translate }}</span>
                @for (offer of conflictedOffers().notToClose; track $index) {
                    <p-chip
                        [label]="$any(offer.offer) | formatOfferDuration"
                        [pTooltip]="offer.offer.name"
                        [ngStyle]="{ 'background-color': offer.offer.color || DEFAULT_TAG_COLOR, 'border-radius': '16px', color: (offer.offer.color || DEFAULT_TAG_COLOR) | colorContrast }"
                    ></p-chip>
                }
            </div>
        </app-error-float-message>
    }
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons
        [primaryButtonDisability]="isInvalid(form) || conflictedOffers().toClose.length > 0 || conflictedOffers().notToClose.length > 0"
        (primaryClickEvent)="save($event)"
        (secondaryClickEvent)="dialogRef.close()"
    ></app-action-buttons>
</div>
